// Modules
import React from 'react'
import { Icon, theme } from '@dasa-health/components-react'
import { SystemBoldCheckmark, SystemBoldClose, SystemBoldRemove } from '@dasa-health/icons'

// Application
import { classNameCheck } from 'utils/getInputValidation'

// Component
import { StyledSpan } from './style'

interface Props {
    touched: boolean | undefined
    valid: boolean | undefined
    text: string
    dirty?: boolean
}

export const ValidInformation: React.FC<Props> = ({ touched, valid, text, dirty }) => {
    const RenderIcon = (): JSX.Element => {
        if (!touched) {
            return <SystemBoldRemove color={theme.colors.grays[50]} data-testid="validinformation-remove" />
        }
        if (valid) {
            return <SystemBoldCheckmark data-testid="validinformation-checkmark" />
        }
        return <SystemBoldClose data-testid="validinformation-close" />
    }
    const checkValid = (): boolean | undefined => {
        if (touched === undefined && !dirty) {
            return undefined
        }
        return valid
    }
    return (
        <div>
            <Icon size="small" variant={classNameCheck(touched, dirty, valid)}>
                {<RenderIcon />}
            </Icon>
            <StyledSpan data-testid="validinformation-text" valid={checkValid()}>
                {text}
            </StyledSpan>
        </div>
    )
}
